const Loading = () => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-canvas/80 dark:bg-carbon/80">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-hairline border-t-primary" />
    </div>
);

export default Loading;
